export const ESTADOS = 220
export const ASIGNATURAS = 222
export const PROGRAMAS = 5
export const TIPOS_SOLICITUDES = 221